import axios from "axios";

export const GET_PROJECTS_LIST = "/projects/getProjectsList";
export const CREATE_PROJECT = "/projects/createProject";
export const EDIT_PROJECT = "/projects/editProject";
export const DELETE_PROJECT = "/projects/deleteProject";
export const ADD_CUSTOMER_TO_PROJECT = "/projects/addCustomerToProject";
export const REMOVE_CUSTOMER_FROM_PROJECT = "/projects/removeCustomerFromProject";
export const GET_CUSTOMERS_FOR_PROJECTS = "/projects/getCustomersForProjects";
export const GET_PROJECTS_FILE = "/projects/getDataForCSVExport";
export const UPLOAD_FILE = "/projects/importDataFromFile";

export function getProjectsList(queryParams, cancellationHandlers) {
  return axios.get(GET_PROJECTS_LIST, {params: queryParams, ...cancellationHandlers});
}

export function createProject(name) {
  return axios.post(CREATE_PROJECT, name);
}

export function editProject(id, name) {
  return axios.post(EDIT_PROJECT, {id, name});
}

export function deleteProject(id) {
  return axios.post(DELETE_PROJECT, id);
}

export function addCustomerToProject(projectId, customerId) {
  return axios.post(ADD_CUSTOMER_TO_PROJECT, {projectId, customerId});
}

export function removeCustomerFromProject(projectId, customerId) {
  return axios.post(REMOVE_CUSTOMER_FROM_PROJECT, {projectId, customerId});
}

export function getCustomersForProjects(params, cancellationHandlers) {
  return axios.get(GET_CUSTOMERS_FOR_PROJECTS, {params, ...cancellationHandlers});
}

export function getProjectsFile(projectID) {
  return axios.get(GET_PROJECTS_FILE, {params: projectID});
}

export function uploadFile({formData}) {
  return axios.post(UPLOAD_FILE, formData, {
    headers: {
      'content-type': 'multipart/form-data'
    }
  });
}
